<template>
  <div class="col">

    <div class="row mt-5 ">
      <div class="col">
        <h5>{{ orderProduct.productName }}</h5>
        <p>{{ order.packingListNumber }}</p>
      </div>
      <div class="col">
        <button class='btn btn-primary float-right' @click="goBack()"
        > {{ $t('button.back') }}
        </button>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <div class="order-destination">
          <orderDestination :order="order"/>
        </div>
      </div>
    </div>
    <div class="row mt-5 ">
      <div class="col-12">
        <div class="custom-control custom-checkbox">
          <input v-model="orderProduct.barcodeUnreadable"
                 type="checkbox"
                 @change="barcodeUnreadableChanged = true;"
                 :id="orderProduct.productNumber"
                 class="custom-control-input"
          />
          <label class="custom-control-label" :for="orderProduct.productNumber">
            <span>{{ $t('shopfloor.loadingPage.barcodeUnreadable') }}</span>
          </label>
        </div>
      </div>

    </div>
    <div class="row mt-5 ">
      <div class="col">
        <label
            for="description_pickable">{{ $t('shopfloor.teamlead.manual.orderProduct.amountPickableTitle') }} </label>
        <p id="description_pickable" v-html="$t('shopfloor.teamlead.manual.orderProduct.description')"/>
      </div>
      <div class="col">
        <label for="amountPickable">{{ $t('shopfloor.teamlead.manual.orderProduct.amountPickable') }}</label>
        <div class="input-group input-group-lg">
          <div class="input-group-prepend">
            <button @click="orderProduct.amount--; toPickChange--" :disabled="orderProduct.amount <=0"
                    class="btn btn-default"
                    id="inputGroup-sizing-lg11">
              <i class="fas fa-minus"/>
            </button>
          </div>
          <input type="text" id="amountPickable" class="form-control" v-model="orderProduct.amount"
                 aria-label="Large" aria-describedby="inputGroup-sizing-sm">
          <div class="input-group-append">
            <button @click="orderProduct.amount++; toPickChange++" class="btn btn-default" id="inputGroup-sizing-lg12">
              <i class="fas fa-plus"/>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-5 ">
      <div class="col">
        <button class="btn btn-primary" @click="save()">Save</button>
      </div>

    </div>


  </div>

</template>


<script>
import {mapGetters} from 'vuex';
import orderDestination from './../../components/loading/OrderDestination';
import {swalModals} from './../../mixins/swalModals';


export default {
  props: ['order', 'product'],
  mixins: [swalModals],
  components: {
    orderDestination
  },
  data() {
    return {
      orderProduct: {},
      hasChanges: false,
      originalObject: undefined,
      toPickChange: 0,
      barcodeUnreadableChanged: false
    };
  },
  firestore() {
    return {
      orderProduct: this.$FB.collection('order-products').doc(this.product.id)
    };
  },
  computed: {
    ...mapGetters('users', [
      'getMeBasic'
    ])
  },
  methods: {
    async save() {
      if (this.toPickChange !== 0 || this.barcodeUnreadableChanged) {
        await this.$FB.collection('manual-adjustments').add({
          manualChangesToPick: this.toPickChange,
          manualChangesPicked: 0,
          user: this.getMeBasic,
          pickLocationAtThatTime: null,
          adjustedAt: new Date(),
          packingListNumber: this.order.packingListNumber,
          productNumber: this.product.productNumber,
          companyId: this.getMeBasic.companyId,
          barcodeUnreadableChanged: this.barcodeUnreadableChanged,
          barcodeUnreadable: this.orderProduct.barcodeUnreadable ? true : false, // ifelse to catch undef
        });
      }
      this.$FB.collection('order-products').doc(this.product.id).update({
        manualAdjustment: true,
        manualAdjustmentBy: this.getMeBasic.userName,
        barcodeUnreadable: this.orderProduct.barcodeUnreadable ? this.orderProduct.barcodeUnreadable : false,
        amount: this.orderProduct.amount,
        fullyPicked: this.orderProduct.amount == 0
      }).then(() => {
        this.hasChanges = false;
        this.$swal({
          customClass: {
            header: 'align-items-center'
          },
          toast: true,
          position: 'bottom-end',
          showConfirmButton: false,
          timer: 5000,
          type: 'success',
          title: this.$root.$t('shopfloor.teamlead.loading.saveSuccess')
        });
        this.goBack();
      });
    },
    goBack() {
      if (this.hasChanges) {
        return this.swalUnsavedChanges().then(res => {
          if (res.value == true) {
            this.$router.go(-1) //  this.$router.push({path: '/loading/cargo/' + this.order.cargoId +'?orderId='+this.order.id});
          }
        });
      } else {
        this.$router.go(-1) //this.$router.push({path: '/loading/cargo/' + this.order.cargoId +'?orderId='+this.order.id});
      }
    }
  },
  watch: {
    orderProduct(newV, oldV) {
      this.originalObject = _.cloneDeep(newV);
      if (newV.name && oldV.name && newV.name !== oldV.name) {
        this.hasChanges = true;
      }
    },
    'orderProduct.amount': function (newV, oldV) {
      if (!_.isEqual(this.originalObject, this.orderProduct)) {
        this.hasChanges = true;
      } else {
        this.hasChanges = false; // Changes are back to original, so no changes
      }
    },
    'orderProduct.barcodeUnreadable': function (newV, oldV) {
      if (!_.isEqual(this.originalObject, this.orderProduct)) {
        this.hasChanges = true;
      } else {
        this.hasChanges = false; // Changes are back to original, so no changes
      }
    },
  },
  created() {
  }
};
</script>

<style lang="scss" scoped>
.fully-picked {
  color: green;
}

.not-fully-picked {
  color: red;
}
</style>